import { useCallback, useState } from 'react';

import { ControlledConfirmationPopover } from '@/components/ConfirmationPopover';
import { PureSwitch } from '@/components/form/Switch';
import { useAppAlert } from '@Components/AppAlert';
import { getInfo } from '@Components/Grid/components/Table/formatters';
import { useGrid } from '@Components/Grid/context';

export default function ToggleFormatter({ info }) {
  const { row, field, value } = getInfo(info)
  const { definitions: { entityName }, events: { handleUpdateEntry } } = useGrid()
  const { handleSuccess } = useAppAlert()
  const [updating, setUpdating] = useState(false)

  const handleUpdateActive = useCallback(async () => {
    setUpdating(true)
    await handleUpdateEntry({ id: row.id, [field]: !value }).finally(() => setUpdating(false))
    handleSuccess(`${entityName} edited!`)
  }, [handleUpdateEntry, field, row, value, handleSuccess, entityName])

  const switchEl = <PureSwitch value={updating ? !value : value} disabled={updating} />

  if (value) {
    return (
      <ControlledConfirmationPopover
        onSubmit={handleUpdateActive}
        title={<span>Deactivate {entityName.toLowerCase()} <i>{`[#${row.id}] ${row.name || ''}`}</i></span>}
        target={switchEl}
      >
        <p><strong>Are you sure you want to deactivate this?</strong></p>
      </ControlledConfirmationPopover>
    )
  }

  return <PureSwitch value={updating ? !value : value} onChange={handleUpdateActive} disabled={updating} />
}
